module.exports = __webpack_public_path__ + "static/media/Tips_para_comprar_un_usado.c70934ae.pdf";